import { IconCloseMS, IconDocumentMS, IconEditMS } from '@/constants/icons';
import { IconButton } from '@mui/material';

import { DocumentUploadBox } from '../DocumentUploadBox';
import {
  CardWrapper,
  DeleteIconButton,
  DocName,
  FileCard,
  FileInfo,
  FileName,
  FileSize,
} from './styles';

function formatFileSize(bytes: number): string {
  if (bytes < 1000 * 1000) return `${(bytes / 1000).toFixed(1)} KB`;
  return `${(bytes / (1000 * 1000)).toFixed(1)} MB`;
}

interface DocumentCardProps {
  name: string;
  file?: File;
  fileName?: string;
  fileSize?: number;
  onFileSelect?: (file: File) => void;
  inputId?: string;
  onEdit?: () => void;
  onDelete?: () => void;
  onDownload?: () => void;
  onDrawer?: boolean;
}

export function DocumentCard({
  name,
  file,
  fileName,
  fileSize,
  onFileSelect,
  inputId,
  onEdit,
  onDelete,
  onDownload,
  onDrawer = false,
}: DocumentCardProps): JSX.Element {
  const displayName = file?.name ?? fileName ?? name;
  const sizeLabel = file?.size ?? fileSize;
  const fileSizeText = sizeLabel ? ` • ${formatFileSize(sizeLabel)}` : '';
  return (
    <CardWrapper>
      {!onDrawer && <DocName title={name}>{name}</DocName>}
      {!file && onFileSelect ? (
        <DocumentUploadBox onFileSelect={onFileSelect} inputId={inputId} />
      ) : (
        <FileCard>
          {IconDocumentMS}
          <FileInfo>
            <FileName
              title={displayName}
              onClick={onDownload}
              sx={onDownload ? { cursor: 'pointer' } : undefined}
            >
              {displayName}
            </FileName>
            <FileSize>PDF{fileSizeText}</FileSize>
          </FileInfo>
          {onEdit && (
            <IconButton onClick={onEdit} size="small">
              {IconEditMS}
            </IconButton>
          )}
          {onDelete && (
            <DeleteIconButton onClick={onDelete} size="small">
              {IconCloseMS}
            </DeleteIconButton>
          )}
        </FileCard>
      )}
    </CardWrapper>
  );
}
